import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import type { HeaderActionsProps } from '../HeaderActions/HeaderActions';
import { HeaderBulkActions } from '../HeaderActions/HeaderBulkActions';

const StyledCloseIconButton = styled(IconButton)`
  font-size: 20px;
  padding: 0px;
`;

const StyledDivider = styled(Divider)`
  align-self: center;
  height: 20px;
  margin: ${({ theme }) => theme.spacing(0, 2)};
  opacity: 0.4;
`;

interface BulkOperationsProps<ItemType> extends HeaderActionsProps {
  selectedItems: ItemType[];
  onClose: () => void;
}

export function BulkOperations<ItemType>({ selectedItems, actions, onClose }: BulkOperationsProps<ItemType>) {
  const { t } = useTranslation();

  return (
    <Grid
      container
      wrap="nowrap"
      data-test="bulk-action"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Grid
        container
        wrap="nowrap"
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography variant="body1">
          {selectedItems.length} {t('selected')}
        </Typography>
        <StyledDivider orientation="vertical" flexItem />
        <Grid>
          <HeaderBulkActions actions={actions} />
        </Grid>
      </Grid>
      <StyledCloseIconButton
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={onClose}
        data-test="bulk-close"
        size="large"
      >
        <CloseIcon />
      </StyledCloseIconButton>
    </Grid>
  );
}
